import { Col, Row } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import ReportTable from '../../../../components/DashboardPage/ReportTable';
import { generateReportQueryStringFromQuery } from '../TicketReport/TicketReportFiltersContainer';

const AgentStatusSnapshotReportItemsContainer = () => {
    const { query } = useRouter();
    const { t } = useTranslation('reports');
    const queryString = generateReportQueryStringFromQuery(query);
    return (
        <>
            <Row style={{ justifyContent: 'space-evenly' }}>
                <Col span={17}>
                    <ReportTable
                        agentSearchable
                        url={queryString ? `/reports/agents/assignee-status-report?${queryString}` : null}
                        title={t('agentStatusSnapshotReports.reportItems.ticketStatusByAgentReportSnapshot')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default AgentStatusSnapshotReportItemsContainer;
